<template>
  <div class="home">
    <div class="header">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <!--  v-model:startTime="listQuery.startTime" v-model:startTime="listQuery.endTime" -->
            <qzf-time v-model:startTime="listQuery.startTime"  v-model:endTime="listQuery.endTime" style="margin:0 5px;transform: translateY(1px);"></qzf-time>

            <el-select @change="getList()" class="input-search" size="mini" v-model="listQuery.status" placeholder="开票状态" style="width:130px">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-input style="width:150px" class="input-search" size="mini" v-model="listQuery.fpdm" placeholder="发票代码" />
            <el-input style="width:150px" class="input-search" size="mini" v-model="listQuery.fphm" placeholder="发票号码" />
            <invoice-type v-model:code="listQuery.fplxdm" style="transform: translateY(1px);"></invoice-type>
            <el-button size="mini" type="primary" @click="getList()">搜索</el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="right">
            <fpxf @success="getList()"></fpxf>
            <!-- <fpupdate @success="getList()"></fpupdate> -->
            <el-button @click="excel()" size="mini" type="primary" plain>导出</el-button>
            <el-dropdown size="mini" style="margin-left:10px">
              <el-button size="mini" type="primary" plain>
                更多
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <el-button type="primary" size="mini" plain @click="piliang('pdf')">批量下载pdf</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button type="primary" size="mini" plain @click="piliang('ofd')">批量下载ofd</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button type="primary" size="mini" plain @click="shangchuan()">上传验签</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <!-- <el-button @click="gogogo()" size="mini" type="primary">gogogo</el-button> -->
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table size="mini" :data="tableData"  border style="width: 100%" :header-cell-style="{background:'#66b1ff',color:'#ffff'}" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column fixed type="index" width="50" label="序号" align="center" :index="computeTableIndex"></el-table-column>
      <el-table-column label="开票状态" width="160" align="center">
        <template v-slot="scope">
          <el-tooltip :disabled="!scope.row.msg" class="item" effect="dark" :content="scope.row.msg" placement="top-start" >
            <span class="shubiao" :style="{color:(scope.row.status==1 || scope.row.status==4?'green':'red')}">{{ statusFilters(scope.row.status) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column label="发票类型" width="160" align="center">
        <template v-slot="scope">
          <span>{{ $fplx(scope.row.fplxdm) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="kprq" label="开票日期" width="120" align="center">
       <template v-slot="scope">
          {{filterTime(scope.row.kprq)}}
       </template>
      </el-table-column>
      <el-table-column prop="fpdm" label="发票代码" width="200" align="center"/>
      <el-table-column prop="fphm" label="发票号码" width="120" align="center"/>
      <el-table-column prop="kplx" label="开票类型" width="120" align="center">
       <template v-slot="scope">
          {{filter(scope.row.kplx)}}
       </template>
      </el-table-column>
      <el-table-column prop="ghdwmc" label="购货单位名称" width="120" align="center"/>
      <el-table-column prop="jshj" label="价税合计" width="110" align="center"/>
      <el-table-column prop="hjje" label="合计金额" width="160" align="center"/>
      <el-table-column prop="hjse" label="合计税额" width="120" align="center"/>
      <el-table-column prop="kce" label="差额征税扣除额" width="110" align="center"/>
      <el-table-column prop="xhdwmc" label="销货单位名称" width="180" align="center"/>
      <el-table-column prop="fpqqlsh" label="发票请求流水号" width="210" align="center"/>
      <el-table-column prop="yqzt" label="验签状态" width="120" align="center">
       <template v-slot="scope">
         <span :style="{color:(scope.row.yqzt=='0'?'red':'green')}">{{filterYqzt(scope.row.yqzt)}}</span>
       </template>
      </el-table-column>
      <!-- <el-table-column label="二维码" width="160" align="center">
        <template v-slot="scope">
          <img class="img-ewm" :src="findSrc(scope.row.ewm)" alt="">
        </template>
      </el-table-column> -->
      <el-table-column fixed="right" label="操作" min-width="230" align="center">
        <template v-slot="scope">
          <el-button type="text" size="small" @click="syncMx(scope.row)">同步开票信息</el-button>
          <el-button type="text" size="small" @click="handleClick(scope.row)">明细</el-button>
          <el-button type="text" size="small" @click="copy(scope.row)">复制</el-button>
          <el-popconfirm
            confirm-button-text="确认"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="red"
            title="确认作废"
            @confirm="cancelIn(scope.row)"
          >
            <template #reference>
              <el-button type="text" size="small">作废</el-button>
            </template>
          </el-popconfirm>
          <el-button type="text" size="small" @click="open(scope.row)" v-if="scope.row.fplxdm == '028'|| scope.row.fplxdm =='026'">发送邮件</el-button>
          <el-button type="text" size="small" @click="downLoadPdf(scope.row, 'pdf')" v-if="scope.row.fplxdm == '028'">下载pdf</el-button>
          <el-button type="text" size="small" @click="downLoadPdf(scope.row, 'ofd')" v-if="scope.row.fplxdm == '028'">下载ofd</el-button>

          <el-button type="text" size="small" @click="downLoadPdf026(scope.row, 'pdf')" v-if="scope.row.fplxdm == '026'">下载pdf</el-button>
          <el-button type="text" size="small" @click="downLoadPdf026(scope.row, 'ofd')" v-if="scope.row.fplxdm == '026'">下载ofd</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination">
    <qzf-pagination v-show="total>0" :total="total" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
  </div>
  <invoice-detail ref="invoiceDetail" :row=row></invoice-detail>
</template>
<script>
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { invoiceList, cancelInvoice } from "@/api/open";
import fpxf from "@/components/fpxf";
import fpupdate from "@/components/fpupdate";
import { downloadFileByBase64  } from "@/utils/downloadFile";
import { elecInvoiceEmail, InvoicePdf , elecInvoiceZpOfdPdf, corpCustomerInfo, elecInvoicePdf, batchInvoicePdf, invoiceExcel, syncInfo, yanqian } from "@/api/ea";
import md5 from 'js-md5';
export default {
  name: 'invoiceQuery',
  mounted () {
    console.log("2挂载完成")
  },
  data() {
    return {
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
        page: 1,
        limit: 10,
        fpdm: "",
        fphm: "",
        status: 1,
      },
      options: [
        {
          value: 0,
          label: '全部',
        },
        {
          value: 1,
          label: '开票成功',
        },
        {
          value: 2,
          label: '开票失败',
        },
        {
          value: 3,
          label: '开票作废',
        },
        {
          value: 4,
          label: '发票模板',
        }
      ],
      total: 0,
      tableData: [],
      row:{},
      // multipleSelections: [],
      selectionVal:undefined
    }
  },
  components: {
    fpxf,
    fpupdate,
  },
  created () {
    this.getList()
  },
  methods: {
    //同步开票信息
    async syncMx(row,type){
      await syncInfo([{id: row.id}]).then(res=>{
        if(res.data.msg == "success"){
          this.getList()
          if(type != "copy"){
            this.$qzfMessage("同步成功")
          }
        }
      })
    },
    //导出
    excel(){
      invoiceExcel(this.listQuery).then(res=>{
        if(res.data.msg == "success"){
          window.open(res.data.data.url)
        }
      })
    },
    //复制发票 重开
    async copy(row){
      await this.syncMx(row,"copy")//同步信息
      //关闭开具发票的页面重新打开
      this.$store.dispatch("tagsView/delViewByName", 'invoicing') 
      this.$router.push({
        name: "invoicing",
        params: {
          info: JSON.stringify(row)
        },
      });
    },
    gogogo(){
      // this.$router.push({
      //   path: '/invoiceManage/invoicing',
      // });
      let routeData = this.$router.resolve({
        path: "/invoiceManage/invoicing",
        query: {
          name:'lei',
          age: 18,
          phoneNum:12345678901
        }
      });
      window.open(routeData.href, '_blank');

    },
    //作废
    cancelIn(row){
      let param = {
        type: "1",
        id: row.id,
        comId: row.comId,
        fphm: row.fphm,
        fpdm: row.fpdm,
        hjje: row.hjje,
        fphm: row.fphm,
        kpr: row.kpr,
        fplxdm: row.fplxdm,
      }
      cancelInvoice(param).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("作废成功")
          this.getList()
        }
      })
    },
    findSrc(base64){
      return "data:image/png;base64," + base64
    },
    statusFilters(e){
      if(e == 1){
        return "开票成功"
      }else if(e == 3){
        return "开票作废"
      }else if(e == 4){
        return "发票模板"
      }else{
        return "开票失败"
      }
    },
    filter(n){
      if(n == "0"){
        return "正数票开具"
      }else{
        return "负数票开具"
      }
    },
    filterTime(a){
      if(a && a.length > 10)
      return a.substring(0,4) + '-' + a.substring(4,6) + '-' +  a.substring(6,8)
    },
    filterYqzt(n){
      if(n == '0'){
        return "验签失败"
      }else{
        return "验签成功"
      }
    },
    getList(){
      invoiceList(this.listQuery).then(res=>{
        this.total = res.data.data.total
        if(res.data.data.list){
          this.tableData = res.data.data.list
        }
      })
    },
    handleClick(row) {
      this.row = row
      this.$refs.invoiceDetail.dialogVisible = true
    },
    //专票下载
    downLoadPdf(row, type){
      let param = {
        "id": row.id,
      }
      elecInvoiceZpOfdPdf(param).then(res=>{
          if(res.data.msg == "success"){
            let pdf = res.data.data.pdf
            let ofd = res.data.data.ofd
            if(type == "pdf"){
              window.open(pdf)
            }else{
              window.open(ofd)
            }
          }
        })
    },
    //普票下载
    downLoadPdf026(row, type){
      let param = {
        "id": row.id,
      }
      elecInvoicePdf(param).then(res=>{
          if(res.data.msg == "success"){
            let pdf = res.data.data.pdf
            let ofd = res.data.data.ofd
            if(type == "pdf"){
              if(pdf == ""){
                this.$qzfMessage("请先导入签章证书", 1)
              }else{
                window.open(pdf)
                //前端base64 转的 先不用了 后端转
                // downloadFileByBase64(res.data.data.pdf,this.$store.getters['user/comInfo'].name + row.fpdm + "-" + row.fphm)
              }
            }else{
              window.open(ofd)
            }
          }
        })
    },
    open(row) {
      corpCustomerInfo({tax_no:row.ghdwsbh}).then(res=>{
        this.$prompt('请输入邮箱', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue:res.data.data.info.email,
          inputPattern:
            /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: '邮箱格式不正确',
        }).then(({ value }) => {
          let newParam = {
            "mailTo": [value],
            "id":row.id,
          }
          InvoicePdf(newParam).then(res=>{
            if(res.data.msg == "success"){
              this.$qzfMessage("发送成功")
            }
          })
          // let param = {
          //   "fplxdm": row.fplxdm,
          //   "fpdm": row.fpdm,
          //   "fphm": row.fphm,
          //   "email": value,
          // }
          // elecInvoiceEmail(param).then(res=>{
          //   if(res.data.msg == "success"){
          //     this.$qzfMessage("发送成功")
          //   }
          // })
        })
      })
    },
    //序号
    computeTableIndex(index) {
      return (this.listQuery.page - 1) * this.listQuery.limit + index + 1
    },
    handleSelectionChange(val){
      this.selectionVal = val
    },
    shangchuan(){
      if(this.selectionVal.length == 0){
        this.$qzfMessage("请至少选择一条", 1)
        return
      }
      let fplxdm = ""
      for(let i=0;i<this.selectionVal.length;i++){
        if(this.selectionVal[i].fplxdm != fplxdm){
          if(fplxdm == ""){
            fplxdm = this.selectionVal[i].fplxdm
          }else{
            this.$qzfMessage("不可同时上传不同发票类型的发票", 1)
            return
          }
        }
      }
      let items = []
      this.selectionVal.map(v=>{
        if(v.kprq){

        }
        items.push({
          "fpdm": v.fpdm,
          "fphm": v.fphm,
          "kprq": v.kprq,
          "jqbh": v.jqbh,
        })
      })
      let param = {
        "comId": this.selectionVal[0].comId,
        "fplxdm": fplxdm,
        "items": items
      }
      yanqian(param).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("上传成功")
        }
      })
    },
    piliang(type){
      this.selectionVal.map(v=>{
        if(v.fplxdm !== "028" && v.fplxdm !== "026"){
          return
        }
        let multipleSelection = []
        this.selectionVal.map(v=>{
          multipleSelection.push({
            id:v.id
          })
        })
        this.multipleSelection = multipleSelection
      })
      if(this.multipleSelection == undefined){
        this.$qzfMessage("请查看是否选择错误", 1)
        return
      }else{
        batchInvoicePdf(this.multipleSelection).then(res=>{
          if(res.data.msg == "success"){
            let pdf = res.data.data.pdf
            let ofd = res.data.data.ofd
            if(type == "pdf"){
              window.open(pdf)
            }else{
              window.open(ofd)
            }
          }
        })
      }
    },

  },
  activated () {
    
  },
  setup() {
    onBeforeUnmount(()=>{
      console.log("2销毁")
    })
  },
}
</script>
<style lang="scss">
.shubiao{
 cursor: pointer; 
}
</style>
<style lang="scss" scoped>
.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.home{
  padding: 10px;
  .header{
    margin-bottom: 10px;
    .right{
      float: right;
    }
    .input-search{
      width: 180px;
      margin-right: 5px;
    }
  }
  .img-ewm{
    width: 50px;
  }
}
.pagination{
  text-align: right;
  margin-right: 26px;
  margin-top: 16px;
}
</style>